import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./CenterPrinter.scss";
import Table from "../../../../Components/Table/Table";
import CustomToolbar from "../../../../Components/Table/components/CustomToolbar";
import ButtonField from "../../../../Components/Button/ButtonField";
import { Columns } from "../../../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import Dialog from "../../../../Components/Dialog/Dialog";
import ResponseDialog from "../../../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../../../Assets/Images/RefreshButton.svg";

// Form
import CenterPrinterForm from "./CenterPrinterForm";
import {
  ICenterPrinter,
  ICenterPrinterPayload,
  ICenterPrinterRow,
  IMapping,
} from "./ICenterPrinter";
import { centreMasterMappingRead } from "../../../../Redux/Slices/Booklet/Admin/CentreMasterMapping/CentreMatserMappingRead";
import {
  centreMasterMappingCreate,
  clearCentreMasterMappingCreate,
} from "../../../../Redux/Slices/Booklet/Admin/CentreMasterMapping/CentreMasterMappingCreate";

const CenterPrinter: FunctionComponent = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<Partial<ICenterPrinter>>({
    status: true,
  });

  const dispatch = useAppDispatch();
  const { data: listCenterPrinters, isLoading } = useAppSelector(
    (state) => state.CentreMasterMappingReadSlice
  );
  const { data: addOrUpdateCenterPrinter } = useAppSelector(
    (state) => state.CentreMasterMappingCreateSlice
  );

  const formRef = useRef<HTMLFormElement>(null);

  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "center_printer_id",
    //   renderHeader: () => <b>Center Printer ID</b>,
    //   flex: 1,
    // },
    {
      field: "center_name",
      renderHeader: () => <b>Center</b>,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "printer_data",
      renderHeader: () => <b>Printer</b>,
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row.printer_data?.printer_name || "",
      renderCell: (params: GridRenderCellParams<ICenterPrinter>) => (
        <div>{params.row.printer_data?.printer_name || "-"}</div>
      ),
    },

    // {
    //   field: "tutor_names",
    //   headerAlign: "center",
    //   align: "center",
    //   renderHeader: () => <b>Tutor Name(s)</b>,
    //   flex: 1,
    //   renderCell: (params: GridRenderCellParams<ICenterPrinterTableRow>) => (
    //     <div>
    //       {params.row.tutor_names?.map((tutorName: string, index: number) => (
    //         <div key={index}>{tutorName}</div>
    //       ))}
    //     </div>
    //   ),
    // },
    {
      field: "status",
      headerAlign: "center",
      align: "center",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,
      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<ICenterPrinter>) => (
        <>
          <IconButtonField
            onClick={() => {
              const rowData = params.row;

              const formData: ICenterPrinterPayload = {
                center_printer_id: rowData.center_printer_id,
                center_id: rowData.center_data.center_id || "",
                status: rowData.status,
                is_delete: rowData.is_delete || false,
                printer_id: rowData.printer_data?.printer_id || "",
              };
              setInitialValues(formData);
              setDialogOpen(true);
            }}
          >
            <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
          </IconButtonField>
          <IconButtonField
            onClick={() => {
              dispatch(clearCentreMasterMappingCreate());
              setDeleteData({
                id: params.row.center_printer_id,
                name: "the data",
                // refactor later
              });
              setDeleteDialogOpen(true);
            }}
          >
            <SvgIcon component={Delete} inheritViewBox />
          </IconButtonField>
        </>
      ),
    },
  ];

  const rows: ICenterPrinterRow[] = Array.isArray(listCenterPrinters?.data)
    ? (listCenterPrinters?.data ?? []).map((row, index) => {
      // Use the direct printer_data from the API response
      const printerData = row.printer_data;

      return {
        ...row,
        id: row.center_printer_id,
        index: index + 1,
        center_id: row.center_data?.center_id ?? "",
        center_name: row.center_data?.center_name ?? "",
        printer_data: printerData
          ? {
            printer_id: printerData.printer_id || "",
            printer_name: printerData.printer_name || "",
            model: printerData.model,
            status: printerData.status,
          }
          : undefined,
      };
    })
    : [];

  useEffect(() => {
    dispatch(centreMasterMappingRead());
  }, [addOrUpdateCenterPrinter, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearCentreMasterMappingCreate());
    };
  }, [dispatch]);

  return (
    <>
      <Table rows={rows} columns={columns} loading={isLoading}>
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({
                center_printer_id: "0",
                center_id: "",
                status: true,
                is_delete: false,
                printer_id: "",
              });
              setDialogOpen(true);
            }}
            toolTip="Add new"
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(centreMasterMappingRead())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${initialValues?.center_printer_id &&
          initialValues.center_printer_id !== "0"
          ? "Update"
          : "Add"
          } Center Printer`}
        Dialog_Content={
          <CenterPrinterForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
            response={addOrUpdateCenterPrinter}
            centerprinterdata={rows}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setInitialValues({ status: true });
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        response={addOrUpdateCenterPrinter}
        parentDialog={setDialogOpen}
      />

      {deleteDialogData && deleteDialogOpen && (
        <DeleteDialog
          deleteableName={deleteDialogData.name ?? ""}
          open={deleteDialogOpen}
          setOpen={setDeleteDialogOpen}
          deleteFunction={() => {
            if (deleteDialogData.id) {
              dispatch(
                centreMasterMappingCreate({
                  center_printer_id: String(deleteDialogData.id),
                  center_id: "",
                  printer_id: "",
                  status: false,
                  is_delete: true,
                })
              );
            }
          }}
          response={addOrUpdateCenterPrinter}
        />
      )}
    </>
  );
};

export default CenterPrinter;
